export default __webpack_public_path__ + "static/media/452.c5fe185a.gif";